<template>
    <div class="stat-list">
        <h3>{{ title }}</h3>
        <ul>
            <li v-for="[key, value] in limitedItems" :key="key">
                <div class="label">{{ key }}</div>
                <div class="value-group">
                    <div class="value">{{ value }}</div>
                    <div v-if="total !== undefined" class="percentage">
                        {{ formatPercentage(value, total) }}
                    </div>
                </div>
            </li>
        </ul>
        <div v-if="showAllVisible" class="show-all" @click="openModal">
            Show all
        </div>

        <div v-if="showModal" class="modal-overlay" @click.self="closeModal">
            <div class="modal-content">
                <div class="modal-header">
                    <h3>All {{ title }}</h3>
                    <button class="modal-close" @click="closeModal">×</button>
                </div>
                <div class="modal-body">
                    <ul>
                        <li v-for="[key, value] in allItems" :key="key">
                            <div class="label">{{ key }}</div>
                            <div class="value-group">
                                <div class="value">{{ value }}</div>
                                <div
                                    v-if="total !== undefined"
                                    class="percentage"
                                >
                                    {{ formatPercentage(value, total) }}
                                </div>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        title: {
            type: String,
            required: true
        },
        items: {
            type: Object,
            required: false,
            default: () => ({})
        },
        total: {
            type: Number,
            required: false,
            default: 0
        }
    },

    data() {
        return {
            maxItems: 5,
            showModal: false
        };
    },

    computed: {
        limitedItems() {
            return this.allItems.slice(0, this.maxItems);
        },

        allItems() {
            return Object.entries(this.items);
        },

        showAllVisible() {
            return Object.entries(this.items).length > this.maxItems;
        }
    },

    methods: {
        formatPercentage(value, total) {
            if (!total || total === 0) {
                return '0%';
            }

            const percent = (value / total) * 100;

            return `${Math.round(percent)}%`;
        },

        openModal() {
            this.showModal = true;
            document.body.style.overflow = 'hidden';
        },

        closeModal() {
            this.showModal = false;
            document.body.style.overflow = '';
        }
    }
};
</script>
